import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TableColumnsConfigKey } from '@app/core/models/configuration/table-columns-config-key.model';
import { InvoicePPRLogModel } from '@app/core/models/invoices/invoice-pprlog.model';
import { InvoiceModel } from '@app/core/models/invoices/invoice.model';

@Component({
  selector: 'app-invoice-list-pprerrors',
  templateUrl: './invoice-list-pprerrors.component.html',
  styleUrls: ['./invoice-list-pprerrors.component.scss']
})
export class InvoiceListPPRErrorsComponent {

  private invoice: InvoiceModel;
  public logsInError: Array<InvoicePPRLogModel>;
  public configKey: string;
  public exportFileName: string;

  constructor(
    public dialogRef: MatDialogRef<InvoiceListPPRErrorsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
      this.invoice = data.invoice;
      this.logsInError = this.invoice.InvoicePPRLogs.filter(x => x.IsInError);
      this.configKey = TableColumnsConfigKey.INVOICEMODALPPRLOGS;
      this.exportFileName = `${this.invoice.Id}_Erreur_PrimPromo`
    }

  close(): void {
    this.dialogRef.close();
  }
}
